import React from "react";
import { useSelector } from "react-redux";
import { Chip, Tooltip } from "@mui/material";
import HealingIcon from "@mui/icons-material/Healing";

/**
 * "Remediate now" indicator for CSPM check rows.
 * Request Fix is only available from the resource drawer (failed resources).
 */
const RequestFixButton = ({ checkId, showPill = true, failedCount = 0 }) => {
  const remediable = useSelector((s) => s.remediation?.remediableChecks);
  const isRemediable = Array.isArray(remediable?.ids) && remediable.ids.includes(checkId);
  const hasFailedResources = Number(failedCount) > 0;

  if (!isRemediable || !showPill || !hasFailedResources) return null;

  return (
    <Tooltip title="One-click remediation is available — open failed resources to request a fix." arrow placement="top">
      <Chip
        size="small"
        icon={<HealingIcon fontSize="small" />}
        label="Remediate now"
        sx={{
          backgroundColor: "#e8f5e9",
          color: "#2e7d32",
          fontWeight: 600,
          fontSize: 11,
          height: 22,
          "& .MuiChip-icon": { color: "#2e7d32" },
        }}
      />
    </Tooltip>
  );
};

export default RequestFixButton;
